import { all } from 'redux-saga/effects';

import { addSuperUserSagaWatcher} from './add_superuser.saga'
import { getSuperUserSagaWatcher } from './get_superuser.saga'
import {getSuperUsersSagaWatcher} from './get_superusers.saga'
import { selectSuperUserSagaWatcher } from './select_superuser.saga'
import { updateSuperUserSagaWatcher } from './update_superuser.saga'


export default function* superUserSaga() {
    yield all([
        addSuperUserSagaWatcher(),
        getSuperUserSagaWatcher(),
        getSuperUsersSagaWatcher(),
        selectSuperUserSagaWatcher(),
        updateSuperUserSagaWatcher()
    ])
}